// plugins/phoneFormatter.js
export default function ({ app }, inject) {
  inject('phoneFormatter', {
    /**
     * Функция format принимает строку, представляющую номер телефона,
     * и возвращает форматированный номер в виде строки.
     * @param input - Строка, представляющая номер телефона.
     * @returns Форматированный номер телефона в виде строки, например, '+7(123)456-78-90'.
     */
    format(input) {
      const phone = input.replace(/\D/g, '').slice(0, 11)
      let formattedPhone = '+7'

      if (phone.length > 0) formattedPhone += '('
      if (phone.length > 1) formattedPhone += phone.substring(1, 4)
      if (phone.length > 4) formattedPhone += ')' + phone.substring(4, 7)
      if (phone.length > 7) formattedPhone += '-' + phone.substring(7, 9)
      if (phone.length > 9) formattedPhone += '-' + phone.substring(9, 11)

      return formattedPhone
    },
  })
}
